/**
 * @fileoverview AuthLoginSettings - Combined authentication and login settings
 * Groups SSO/LDAP configuration and Password/Session policies into a single tab
 */
import React from "react";
import { intl, DmsTabber, havePermissions } from "dmsbasereact";
import { Box, Typography } from "@mui/material";
import { AuthenticationSettings } from "../AuthenticationSettings/AuthenticationSettings";
import { LoginSettings } from "../LoginSettings/LoginSettings";
import { Permissions } from "../../constants/Permissions";

export const AuthLoginSettings = () => {
    // Build sub-tabs array based on user permissions
    const subTabs = [];

    // SSO/LDAP sub-tab
    if (havePermissions([Permissions.CAN_MANAGE_SSO_SETTINGS])) {
        subTabs.push({
            title: intl.get("SsoLdap").d("SSO / LDAP"),
            component: <AuthenticationSettings />
        });
    }

    // Password & Session sub-tab
    if (havePermissions([Permissions.CAN_MANAGE_LOGIN_SETTINGS])) {
        subTabs.push({
            title: intl.get("PasswordSession").d("Password & Session"),
            component: <LoginSettings />
        });
    }

    return (
        <Box>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                {intl.get("AuthLoginDescription").d(
                    "Configure authentication methods (SSO, LDAP) and login policies (password requirements, session timeouts)."
                )}
            </Typography>
            <DmsTabber tabs={subTabs} pageName={intl.get("AuthLogin").d("Auth & Login")} variant="scrollable" />
        </Box>
    );
};
